'use strict';

var _rollupPluginBabelHelpers = require('../../_virtual/_rollupPluginBabelHelpers.js');
var platform = require('platform');
var index = require('../../module/index.js');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var platform__default = /*#__PURE__*/_interopDefault(platform);

var _excluded = ["properties"];
var actionWrapper = function actionWrapper(action_creator) {
  return function (_ref) {
    var _ref$payload = _ref.payload,
      properties = Object.assign({}, (_rollupPluginBabelHelpers.objectDestructuringEmpty(_ref$payload.properties), _ref$payload.properties)),
      rest = _rollupPluginBabelHelpers.objectWithoutPropertiesLoose(_ref$payload, _excluded),
      dispatch = _ref.instance.dispatch;
    return dispatch(action_creator(Object.assign({
      properties: Object.assign({}, properties, {
        platform: platform__default["default"]
      })
    }, rest)));
  };
};

// const actionWrapper = (action_creator) => (payload) => { console.log('iuwneifun', payload)}

function analyticsPluginDispatchAction() {
  return {
    name: 'analytics-plugin-dispatch-action',
    track: actionWrapper(index.creators.trackEvent),
    identify: actionWrapper(index.creators.identifyUser),
    page: actionWrapper(index.creators.pageVisit),
    reset: actionWrapper(index.creators.reset),
    guest: actionWrapper(index.creators.setGuest),
    user: actionWrapper(index.creators.setUser)
  };
}

module.exports = analyticsPluginDispatchAction;
//# sourceMappingURL=index.js.map
